<div class="wizard-step" *ngIf="section" [formGroup]="form">
  <div class="step-content d-flex flex-column gap-3">
    <div class="step-heading text-center text-md-start">
      <h2 class="step-title">
        {{ section.title }}
      </h2>

      <p *ngIf="section.description" class="step-description">
        {{ section.description }}
      </p>
    </div>

    <div class="row g-3 g-md-3">
      <ng-container *ngFor="let item of displayItems; trackBy: trackItem">
        <div
          *ngIf="item.kind === 'question' && shouldShow(item.question)"
          class="col-12"
        >
          <div class="py-3 pb-2 h-100">
            <div class="mb-2">
              <label class="form-label fw-semibold mb-0" [attr.for]="item.question.key">
                {{ labelFor(item.question) }}
              </label>
              <div>
                <small *ngIf="helperText(item.question)" class="form-text text-muted mb-2">
                  {{ helperText(item.question) }}
                </small>
              </div>
            </div>



            <ng-container [ngSwitch]="item.question.type">
              <input
                *ngSwitchCase="'text'"
                type="text"
                class="form-control form-control-sm"
                [formControlName]="item.question.key"
                (blur)="onChange(item.question)"
                [attr.placeholder]="item.question.placeholder || ''"
              />

              <input
                *ngSwitchCase="'number'"
                type="number"
                class="form-control form-control-sm"
                [formControlName]="item.question.key"
                (blur)="onChange(item.question)"
                [attr.placeholder]="item.question.placeholder || ''"
              />

              <select
                *ngSwitchCase="'select'"
                class="form-select form-select-sm"
                [formControlName]="item.question.key"
                (change)="onChange(item.question)"
              >
                <option *ngIf="item.question.prompt" value="" disabled>
                  {{ item.question.prompt }}
                </option>
                <option *ngFor="let option of item.question.options" [ngValue]="option">
                  {{ option }}
                </option>
              </select>

              <textarea
                *ngSwitchCase="'textarea'"
                rows="3"
                class="form-control form-control-sm"
                [formControlName]="item.question.key"
                (blur)="onChange(item.question)"
                [attr.placeholder]="item.question.placeholder || ''"
              ></textarea>

              <div *ngSwitchCase="'boolean'" class="form-check">
                <input
                  type="checkbox"
                  class="form-check-input"
                  [id]="section.id + '-' + item.question.key"
                  [formControlName]="item.question.key"
                  (change)="onChange(item.question)"
                />
                <label class="form-check-label" [for]="section.id + '-' + item.question.key">
                  {{ form.get(item.question.key)?.value ? 'Yes' : 'No' }}
                </label>
              </div>
            </ng-container>

            <div *ngIf="showErrors && !isQuestionAnswered(item.question)" class="text-danger small mt-1">
              Please answer this question before moving on.
            </div>

          </div>
        </div>

        <div *ngIf="item.kind === 'group'" class="col-12">
          <div class="rounded-3 border border-light bg-white p-3 pb-2 h-100">
            <p class="form-label fw-semibold mb-2">
              {{ item.label }}
            </p>
            <small *ngIf="item.groupDescription" class="form-text text-muted mb-2">
              <ng-container *ngFor="let line of item.groupDescription.split('\\n')">
                {{ line }}<br />
              </ng-container>
            </small>
            <div class="d-flex flex-column gap-2">
              <ng-container *ngFor="let q of item.questions">
                <div class="form-check" *ngIf="shouldShow(q)">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    [id]="section.id + '-' + q.key"
                    [formControlName]="q.key"
                    (change)="onChange(q)"
                  />
                  <label class="form-check-label" [for]="section.id + '-' + q.key">
                    {{ labelFor(q) }}
                  </label>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
